import React from 'react';
import ReactMapboxGl /*, { Layer, Feature }*/ from 'react-mapbox-gl';
import { environment } from '../../environments/environment';


import './map.scss';

const Map = ReactMapboxGl({
  accessToken: environment.mapBoxApiKey
});

interface LatLong {
    latitude: number | undefined
    longitude: number | undefined
}

export default function Mapbox(props: LatLong) {
  const latitude: number = props.latitude ? props.latitude : 0;
  const longitude: number = props.longitude ? props.longitude : 0;

            // <Layer type="symbol" id="marker" layout={{ 'icon-image': 'marker-15' }}>
            //   <Feature coordinates={[-82.8964864, 42.465497599999996]} />
            // </Layer>

  let mapDiv;
  console.log(longitude, latitude);
  if (latitude === 0 && longitude === 0) {
    console.log('loading...');
    mapDiv = <div>
             Loading...
             </div>
  } else {
    console.log('displaying map');
    mapDiv = <Map className="app-map"
                // eslint-disable-next-line react/style-prop-object
                style="mapbox://styles/mapbox/streets-v9"
                center={[longitude, latitude]}
                containerStyle={{
                  height: '50vh'
                }}
              >
          </Map>
  }

return ( 
  <div>
    {mapDiv}
  </div>
  );

};
